import React from 'react';
import get from 'lodash.get';
import { TbHierarchy2 } from 'react-icons/tb';
import { useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import {
  parseObject,
  isUserManager,
  hasPermission,
  isFeatureEnabled,
  getCurrentUserCompany,
} from 'shared/helpers';
import { initialPortalData } from 'shared/constants';
import {
  IconHome,
  IconUser,
  IconLicense,
  IconOrder,
  NavLinkGroup,
  IconLicenseUsers,
} from 'shared/components';
import { NavLink } from '../components';
import './styles.scss';

const Sidebar = () => {
  const { t } = useTranslation();
  const permissionsList = useSelector((state) =>
    get(state, 'user.details.permissions', []),
  );
  const userCompanyData = useSelector((state) => getCurrentUserCompany(state));
  const userDetails = useSelector((state) => get(state, 'user.details'));
  const isManager = isUserManager(userDetails);
  const { portal_data } = userCompanyData;
  const portalData = parseObject(portal_data, initialPortalData);
  const sidebarBackground = get(portalData, 'sidebarBackground', '#fff');

  const accountState = useSelector((state) => state.account);
  const { loading, customerAccounts } = accountState;

  const canCreateOrder = hasPermission(permissionsList, 'create_order');

  return (
    <aside className="Sidebar" style={{ backgroundColor: sidebarBackground }}>
      <div className="Sidebar-inner">
        <NavLink
          activeClassName="NavLink-active"
          className="NavLink"
          exact
          to="/"
        >
          <header>
            <div className="NavLink-icon">
              <IconHome height="20px" width="20px" color="#777" />
            </div>
            {t('Dashboard')}
          </header>
        </NavLink>
        {isManager && canCreateOrder && (
          <NavLink
            activeClassName="NavLink-active"
            className="NavLink"
            to="/create-order"
          >
            <header>
              <div className="NavLink-icon">
                <IconOrder height="16px" width="16px" color="#777" />
              </div>
              {t('Create order')}
            </header>
          </NavLink>
        )}
        {isManager && (
          <NavLink
            activeClassName="NavLink-active"
            className="NavLink"
            to="/orders"
          >
            <header>
              <div className="NavLink-icon">
                <IconOrder height="16px" width="16px" color="#777" />
              </div>
              {t('Orders')}
            </header>
          </NavLink>
        )}
        <NavLink
          activeClassName="NavLink-active"
          className="NavLink"
          to="/licenses"
        >
          <header>
            <div className="NavLink-icon">
              <IconLicense height="16px" width="16px" color="#777" />
            </div>
            {t('Licenses')}
          </header>
        </NavLink>
        <NavLinkGroup
          childLinks={[
            <NavLink
              key="/license_users"
              exact
              to={`/license_users`}
              activeClassName="NavSubLink"
            >
              {t('All License Users')}
            </NavLink>,
            isFeatureEnabled('usage:user-groups') && (
              <NavLink
                key="/license_users/user_groups"
                to={`/license_users/user_groups`}
                activeClassName="NavSubLink"
              >
                {t('User groups')}
              </NavLink>
            ),
          ].filter(Boolean)}
          mainLink={
            <NavLink
              activeClassName="NavLink-active"
              className="NavLink"
              to={`/license_users`}
            >
              <header>
                <div className="NavLink-icon">
                  <IconLicenseUsers height="18px" width="18px" color="#777" />
                </div>
                <span className="NavLink-text">{t('License Users')}</span>
              </header>
            </NavLink>
          }
          path={`/license_users`}
        />
        {!loading && customerAccounts && customerAccounts.length > 0 && (
          <NavLink
            activeClassName="NavLink-active"
            className="NavLink"
            to="/customer-accounts"
          >
            <header>
              <div className="NavLink-icon">
                <TbHierarchy2 size={16} color="#777" />
              </div>
              {t('Customer accounts')}
            </header>
          </NavLink>
        )}
        <NavLink
          activeClassName="NavLink-active"
          className="NavLink"
          to="/profile"
        >
          <header>
            <div className="NavLink-icon">
              <IconUser height="18px" width="20px" color="#777" />
            </div>
            {t('My profile')}
          </header>
        </NavLink>
      </div>
    </aside>
  );
};

export default Sidebar;
